export default [
    [
        { t: 0, x: -1.1725, y: 1.3953, z: 2.5255 },
        { t: 0.016, x: -1.1039, y: 1.4085, z: 3.1551 },
        { t: 0.032, x: -1.0381, y: 1.4187, z: 3.7804 },
        { t: 0.048, x: -0.9751, y: 1.4258, z: 4.4015 },
        { t: 0.064, x: -0.915, y: 1.4297, z: 5.0184 },
        { t: 0.08, x: -0.8578, y: 1.4306, z: 5.631 },
        { t: 0.096, x: -0.8033, y: 1.4285, z: 6.2394 },
        { t: 0.112, x: -0.7518, y: 1.4232, z: 6.8435 },
        { t: 0.128, x: -0.703, y: 1.4149, z: 7.4434 },
        { t: 0.144, x: -0.6571, y: 1.4034, z: 8.039 },
        { t: 0.16, x: -0.614, y: 1.3889, z: 8.6305 },
        { t: 0.176, x: -0.5738, y: 1.3713, z: 9.2176 },
        { t: 0.192, x: -0.5364, y: 1.3507, z: 9.8006 },
        { t: 0.208, x: -0.5018, y: 1.3269, z: 10.3793 },
        { t: 0.224, x: -0.4701, y: 1.3001, z: 10.9538 },
        { t: 0.24, x: -0.4413, y: 1.2702, z: 11.524 },
        { t: 0.256, x: -0.4152, y: 1.2372, z: 12.09 },
        { t: 0.272, x: -0.392, y: 1.2011, z: 12.6517 },
        { t: 0.288, x: -0.3717, y: 1.1619, z: 13.2092 },
        { t: 0.304, x: -0.3541, y: 1.1197, z: 13.7625 },
        { t: 0.32, x: -0.3394, y: 1.0743, z: 14.3115 },
        { t: 0.336, x: -0.3276, y: 1.0259, z: 14.8563 },
        { t: 0.352, x: -0.3186, y: 0.9744, z: 15.3969 },
        { t: 0.368, x: -0.3124, y: 0.9198, z: 15.9332 },
        { t: 0.384, x: -0.3091, y: 0.8622, z: 16.4653 },
        { t: 0.4, x: -0.3086, y: 0.8015, z: 16.9931 },
        { t: 0.416, x: -0.311, y: 0.7376, z: 17.5167 },
        { t: 0.432, x: -0.3162, y: 0.6707, z: 18.0361 },
        { t: 0.4327, x: -0.3165, y: 0.6676, z: 18.0598 }
    ],
    [
        { t: 0, x: -1.1457, y: 1.4292, z: 2.5439 },
        { t: 0.016, x: -1.0824, y: 1.4195, z: 3.1883 },
        { t: 0.032, x: -1.0222, y: 1.4063, z: 3.8287 },
        { t: 0.048, x: -0.9651, y: 1.3897, z: 4.4651 },
        { t: 0.064, x: -0.9112, y: 1.3696, z: 5.0976 },
        { t: 0.08, x: -0.8603, y: 1.3462, z: 5.7262 },
        { t: 0.096, x: -0.8126, y: 1.3193, z: 6.3508 },
        { t: 0.112, x: -0.768, y: 1.2889, z: 6.9714 },
        { t: 0.128, x: -0.7264, y: 1.2552, z: 7.5881 },
        { t: 0.144, x: -0.688, y: 1.218, z: 8.2009 },
        { t: 0.16, x: -0.6527, y: 1.1773, z: 8.8097 },
        { t: 0.176, x: -0.6205, y: 1.1333, z: 9.4145 },
        { t: 0.192, x: -0.5915, y: 1.0858, z: 10.0154 },
        { t: 0.208, x: -0.5655, y: 1.0348, z: 10.6123 },
        { t: 0.224, x: -0.5426, y: 0.9805, z: 11.2053 },
        { t: 0.24, x: -0.5229, y: 0.9227, z: 11.7943 },
        { t: 0.256, x: -0.5062, y: 0.8615, z: 12.3794 },
        { t: 0.272, x: -0.4927, y: 0.7968, z: 12.9606 },
        { t: 0.288, x: -0.4823, y: 0.7288, z: 13.5377 },
        { t: 0.304, x: -0.475, y: 0.6573, z: 14.111 },
        { t: 0.32, x: -0.4708, y: 0.5823, z: 14.6802 },
        { t: 0.336, x: -0.4697, y: 0.5039, z: 15.2456 },
        { t: 0.352, x: -0.4717, y: 0.4221, z: 15.8069 },
        { t: 0.368, x: -0.4769, y: 0.3369, z: 16.3644 },
        { t: 0.384, x: -0.4851, y: 0.2482, z: 16.9178 },
        { t: 0.4, x: -0.4965, y: 0.1562, z: 17.4674 },
        { t: 0.416, x: -0.5109, y: 0.0606, z: 18.0129 },
        { t: 0.4206, x: -0.5156, y: 0.0327, z: 18.1682 }
    ],
    [
        { t: 0, x: -1.1426, y: 1.3918, z: 2.5759 },
        { t: 0.016, x: -1.0847, y: 1.3912, z: 3.2257 },
        { t: 0.032, x: -1.0299, y: 1.3874, z: 3.8713 },
        { t: 0.048, x: -0.9783, y: 1.3806, z: 4.5125 },
        { t: 0.064, x: -0.9299, y: 1.3707, z: 5.1495 },
        { t: 0.08, x: -0.8847, y: 1.3577, z: 5.7823 },
        { t: 0.096, x: -0.8426, y: 1.3416, z: 6.4107 },
        { t: 0.112, x: -0.8037, y: 1.3224, z: 7.0349 },
        { t: 0.128, x: -0.768, y: 1.3001, z: 7.6549 },
        { t: 0.144, x: -0.7355, y: 1.2747, z: 8.2705 },
        { t: 0.16, x: -0.7062, y: 1.2462, z: 8.8819 },
        { t: 0.176, x: -0.68, y: 1.2147, z: 9.4891 },
        { t: 0.192, x: -0.657, y: 1.18, z: 10.0919 },
        { t: 0.208, x: -0.6372, y: 1.1422, z: 10.6905 },
        { t: 0.224, x: -0.6206, y: 1.1014, z: 11.2849 },
        { t: 0.24, x: -0.6071, y: 1.0575, z: 11.8749 },
        { t: 0.256, x: -0.5969, y: 1.0104, z: 12.4607 },
        { t: 0.272, x: -0.5898, y: 0.9603, z: 13.0422 },
        { t: 0.288, x: -0.5859, y: 0.9071, z: 13.6195 },
        { t: 0.304, x: -0.5852, y: 0.8508, z: 14.1925 },
        { t: 0.32, x: -0.5876, y: 0.7914, z: 14.7612 },
        { t: 0.336, x: -0.5932, y: 0.7289, z: 15.3257 },
        { t: 0.352, x: -0.602, y: 0.6633, z: 15.8859 },
        { t: 0.368, x: -0.614, y: 0.5947, z: 16.4418 },
        { t: 0.384, x: -0.6292, y: 0.5229, z: 16.9935 },
        { t: 0.4, x: -0.6475, y: 0.4481, z: 17.5409 },
        { t: 0.416, x: -0.669, y: 0.3701, z: 18.084 },
        { t: 0.4165, x: -0.6697, y: 0.3678, z: 18.0998 }
    ],
    [
        { t: 0, x: -1.1725, y: 1.3658, z: 2.5934 },
        { t: 0.016, x: -1.1031, y: 1.3703, z: 3.2417 },
        { t: 0.032, x: -1.0367, y: 1.3717, z: 3.8856 },
        { t: 0.048, x: -0.9733, y: 1.3701, z: 4.5253 },
        { t: 0.064, x: -0.913, y: 1.3654, z: 5.1607 },
        { t: 0.08, x: -0.8556, y: 1.3576, z: 5.7917 },
        { t: 0.096, x: -0.8012, y: 1.3467, z: 6.4185 },
        { t: 0.112, x: -0.7499, y: 1.3327, z: 7.041 },
        { t: 0.128, x: -0.7015, y: 1.3157, z: 7.6592 },
        { t: 0.144, x: -0.6562, y: 1.2955, z: 8.2731 },
        { t: 0.16, x: -0.6139, y: 1.2723, z: 8.8826 },
        { t: 0.176, x: -0.5745, y: 1.246, z: 9.4879 },
        { t: 0.192, x: -0.5382, y: 1.2166, z: 10.0889 },
        { t: 0.208, x: -0.5049, y: 1.1842, z: 10.6856 },
        { t: 0.224, x: -0.4747, y: 1.1486, z: 11.278 },
        { t: 0.24, x: -0.4474, y: 1.11, z: 11.8661 },
        { t: 0.256, x: -0.4231, y: 1.0683, z: 12.45 },
        { t: 0.272, x: -0.4019, y: 1.0235, z: 13.0295 },
        { t: 0.288, x: -0.3836, y: 0.9756, z: 13.6047 },
        { t: 0.304, x: -0.3684, y: 0.9246, z: 14.1756 },
        { t: 0.32, x: -0.3561, y: 0.8706, z: 14.7422 },
        { t: 0.336, x: -0.3469, y: 0.8135, z: 15.3046 },
        { t: 0.352, x: -0.3407, y: 0.7533, z: 15.8626 },
        { t: 0.368, x: -0.3375, y: 0.69, z: 16.4164 },
        { t: 0.384, x: -0.3373, y: 0.6236, z: 16.9658 },
        { t: 0.4, x: -0.3401, y: 0.5542, z: 17.511 },
        { t: 0.416, x: -0.346, y: 0.4816, z: 18.0518 },
        { t: 0.4176, x: -0.3467, y: 0.4743, z: 18.1053 }
    ],
    [
        { t: 0, x: -1.0652, y: 1.4486, z: 2.5932 },
        { t: 0.016, x: -1.0039, y: 1.4454, z: 3.2597 },
        { t: 0.032, x: -0.9456, y: 1.4399, z: 3.9214 },
        { t: 0.048, x: -0.8901, y: 1.432, z: 4.5784 },
        { t: 0.064, x: -0.8375, y: 1.4217, z: 5.2306 },
        { t: 0.08, x: -0.7878, y: 1.4089, z: 5.8781 },
        { t: 0.096, x: -0.7409, y: 1.3938, z: 6.5209 },
        { t: 0.112, x: -0.697, y: 1.3763, z: 7.1589 },
        { t: 0.128, x: -0.656, y: 1.3564, z: 7.7921 },
        { t: 0.144, x: -0.6178, y: 1.3341, z: 8.4206 },
        { t: 0.16, x: -0.5826, y: 1.3093, z: 9.0443 },
        { t: 0.176, x: -0.5502, y: 1.2822, z: 9.6633 },
        { t: 0.192, x: -0.5208, y: 1.2527, z: 10.2776 },
        { t: 0.208, x: -0.4942, y: 1.2208, z: 10.8871 },
        { t: 0.224, x: -0.4705, y: 1.1864, z: 11.4918 },
        { t: 0.24, x: -0.4497, y: 1.1497, z: 12.0918 },
        { t: 0.256, x: -0.4318, y: 1.1106, z: 12.687 },
        { t: 0.272, x: -0.4168, y: 1.0691, z: 13.2775 },
        { t: 0.288, x: -0.4046, y: 1.0252, z: 13.8633 },
        { t: 0.304, x: -0.3954, y: 0.9788, z: 14.4443 },
        { t: 0.32, x: -0.3891, y: 0.9301, z: 15.0205 },
        { t: 0.336, x: -0.3856, y: 0.879, z: 15.592 },
        { t: 0.352, x: -0.385, y: 0.8255, z: 16.1588 },
        { t: 0.368, x: -0.3874, y: 0.7696, z: 16.7208 },
        { t: 0.384, x: -0.3926, y: 0.7113, z: 17.278 },
        { t: 0.4, x: -0.4007, y: 0.6505, z: 17.8305 },
        { t: 0.4065, x: -0.4048, y: 0.6252, z: 18.0533 }
    ],
    [
        { t: 0, x: -1.061, y: 1.3699, z: 2.5219 },
        { t: 0.016, x: -1.0174, y: 1.379, z: 3.1291 },
        { t: 0.032, x: -0.9736, y: 1.3833, z: 3.7318 },
        { t: 0.048, x: -0.9297, y: 1.3826, z: 4.33 },
        { t: 0.064, x: -0.8857, y: 1.3771, z: 4.9238 },
        { t: 0.08, x: -0.8415, y: 1.3666, z: 5.513 },
        { t: 0.096, x: -0.7972, y: 1.3513, z: 6.0978 },
        { t: 0.112, x: -0.7528, y: 1.3311, z: 6.678 },
        { t: 0.128, x: -0.7083, y: 1.306, z: 7.2538 },
        { t: 0.144, x: -0.6637, y: 1.276, z: 7.8251 },
        { t: 0.16, x: -0.6189, y: 1.2411, z: 8.3919 },
        { t: 0.176, x: -0.574, y: 1.2013, z: 8.9542 },
        { t: 0.192, x: -0.5289, y: 1.1566, z: 9.5121 },
        { t: 0.208, x: -0.4838, y: 1.107, z: 10.0654 },
        { t: 0.224, x: -0.4385, y: 1.0526, z: 10.6143 },
        { t: 0.24, x: -0.3931, y: 0.9932, z: 11.1587 },
        { t: 0.256, x: -0.3476, y: 0.9289, z: 11.6986 },
        { t: 0.272, x: -0.3019, y: 0.8598, z: 12.234 },
        { t: 0.288, x: -0.2562, y: 0.7857, z: 12.7649 },
        { t: 0.304, x: -0.2103, y: 0.7068, z: 13.2913 },
        { t: 0.32, x: -0.1642, y: 0.623, z: 13.8133 },
        { t: 0.336, x: -0.1181, y: 0.5342, z: 14.3307 },
        { t: 0.352, x: -0.0718, y: 0.4406, z: 14.8437 },
        { t: 0.368, x: -0.0254, y: 0.3421, z: 15.3522 },
        { t: 0.384, x: 0.0211, y: 0.2387, z: 15.8562 },
        { t: 0.4, x: 0.0678, y: 0.1304, z: 16.3557 },
        { t: 0.416, x: 0.1146, y: 0.0172, z: 16.8508 },
        { t: 0.432, x: 0.1615, y: -0.1009, z: 17.3413 },
        { t: 0.448, x: 0.2085, y: -0.2239, z: 17.8274 },
        { t: 0.4531, x: 0.2237, y: -0.2645, z: 17.9827 }
    ],
    [
        { t: 0, x: -1.0996, y: 1.432, z: 2.6391 },
        { t: 0.016, x: -1.0513, y: 1.4408, z: 3.2956 },
        { t: 0.032, x: -1.0058, y: 1.4464, z: 3.9479 },
        { t: 0.048, x: -0.963, y: 1.4488, z: 4.596 },
        { t: 0.064, x: -0.923, y: 1.448, z: 5.2398 },
        { t: 0.08, x: -0.8857, y: 1.4441, z: 5.8795 },
        { t: 0.096, x: -0.8512, y: 1.4369, z: 6.5149 },
        { t: 0.112, x: -0.8194, y: 1.4266, z: 7.1461 },
        { t: 0.128, x: -0.7904, y: 1.413, z: 7.7731 },
        { t: 0.144, x: -0.7641, y: 1.3963, z: 8.3958 },
        { t: 0.16, x: -0.7406, y: 1.3764, z: 9.0144 },
        { t: 0.176, x: -0.7199, y: 1.3533, z: 9.6287 },
        { t: 0.192, x: -0.7019, y: 1.327, z: 10.2388 },
        { t: 0.208, x: -0.6866, y: 1.2976, z: 10.8447 },
        { t: 0.224, x: -0.6741, y: 1.2649, z: 11.4463 },
        { t: 0.24, x: -0.6644, y: 1.229, z: 12.0438 },
        { t: 0.256, x: -0.6573, y: 1.19, z: 12.637 },
        { t: 0.272, x: -0.6531, y: 1.1478, z: 13.226 },
        { t: 0.288, x: -0.6516, y: 1.1024, z: 13.8108 },
        { t: 0.304, x: -0.6528, y: 1.0537, z: 14.3914 },
        { t: 0.32, x: -0.6568, y: 1.0019, z: 14.9677 },
        { t: 0.336, x: -0.6636, y: 0.947, z: 15.5398 },
        { t: 0.352, x: -0.6731, y: 0.8888, z: 16.1078 },
        { t: 0.368, x: -0.6854, y: 0.8274, z: 16.6715 },
        { t: 0.384, x: -0.7004, y: 0.7629, z: 17.2309 },
        { t: 0.4, x: -0.7181, y: 0.6951, z: 17.7862 },
        { t: 0.4095, x: -0.73, y: 0.6535, z: 18.1133 }
    ],
    [
        { t: 0, x: -1.0734, y: 1.4414, z: 2.6496 },
        { t: 0.016, x: -1.0326, y: 1.451, z: 3.3081 },
        { t: 0.032, x: -0.9944, y: 1.4581, z: 3.9621 },
        { t: 0.048, x: -0.9589, y: 1.4627, z: 4.6117 },
        { t: 0.064, x: -0.926, y: 1.4647, z: 5.2567 },
        { t: 0.08, x: -0.8957, y: 1.4641, z: 5.8973 },
        { t: 0.096, x: -0.868, y: 1.461, z: 6.5333 },
        { t: 0.112, x: -0.843, y: 1.4553, z: 7.1649 },
        { t: 0.128, x: -0.8206, y: 1.4471, z: 7.792 },
        { t: 0.144, x: -0.8008, y: 1.4364, z: 8.4146 },
        { t: 0.16, x: -0.7836, y: 1.423, z: 9.0327 },
        { t: 0.176, x: -0.769, y: 1.4072, z: 9.6463 },
        { t: 0.192, x: -0.7571, y: 1.3887, z: 10.2554 },
        { t: 0.208, x: -0.7478, y: 1.3678, z: 10.86 },
        { t: 0.224, x: -0.7411, y: 1.3442, z: 11.4601 },
        { t: 0.24, x: -0.7371, y: 1.3181, z: 12.0557 },
        { t: 0.256, x: -0.7356, y: 1.2895, z: 12.6468 },
        { t: 0.272, x: -0.7368, y: 1.2583, z: 13.2335 },
        { t: 0.288, x: -0.7406, y: 1.2246, z: 13.8156 },
        { t: 0.304, x: -0.7471, y: 1.1883, z: 14.3933 },
        { t: 0.32, x: -0.7561, y: 1.1494, z: 14.9664 },
        { t: 0.336, x: -0.7678, y: 1.108, z: 15.5351 },
        { t: 0.352, x: -0.7821, y: 1.0641, z: 16.0993 },
        { t: 0.368, x: -0.799, y: 1.0176, z: 16.659 },
        { t: 0.384, x: -0.8186, y: 0.9685, z: 17.2142 },
        { t: 0.4, x: -0.8407, y: 0.9169, z: 17.7648 },
        { t: 0.4086, x: -0.8537, y: 0.8882, z: 18.0585 }
    ],
    [
        { t: 0, x: -1.0732, y: 1.4275, z: 2.6344 },
        { t: 0.016, x: -1.0253, y: 1.4192, z: 3.2912 },
        { t: 0.032, x: -0.9805, y: 1.4082, z: 3.9439 },
        { t: 0.048, x: -0.9388, y: 1.3944, z: 4.5924 },
        { t: 0.064, x: -0.9001, y: 1.3779, z: 5.2367 },
        { t: 0.08, x: -0.8644, y: 1.3586, z: 5.8768 },
        { t: 0.096, x: -0.8317, y: 1.3366, z: 6.5127 },
        { t: 0.112, x: -0.8021, y: 1.3119, z: 7.1444 },
        { t: 0.128, x: -0.7756, y: 1.2845, z: 7.7719 },
        { t: 0.144, x: -0.752, y: 1.2543, z: 8.3953 },
        { t: 0.16, x: -0.7316, y: 1.2213, z: 9.0144 },
        { t: 0.176, x: -0.7141, y: 1.1856, z: 9.6294 },
        { t: 0.192, x: -0.6997, y: 1.1472, z: 10.2401 },
        { t: 0.208, x: -0.6883, y: 1.1061, z: 10.8467 },
        { t: 0.224, x: -0.68, y: 1.0622, z: 11.4491 },
        { t: 0.24, x: -0.6747, y: 1.0156, z: 12.0473 },
        { t: 0.256, x: -0.6725, y: 0.9662, z: 12.6413 },
        { t: 0.272, x: -0.6733, y: 0.9141, z: 13.2311 },
        { t: 0.288, x: -0.6771, y: 0.8593, z: 13.8167 },
        { t: 0.304, x: -0.684, y: 0.8017, z: 14.3981 },
        { t: 0.32, x: -0.6939, y: 0.7414, z: 14.9754 },
        { t: 0.336, x: -0.7068, y: 0.6783, z: 15.5484 },
        { t: 0.352, x: -0.7228, y: 0.6126, z: 16.1173 },
        { t: 0.368, x: -0.7418, y: 0.544, z: 16.6819 },
        { t: 0.384, x: -0.7639, y: 0.4728, z: 17.2424 },
        { t: 0.4, x: -0.789, y: 0.3988, z: 17.7987 },
        { t: 0.4095, x: -0.8053, y: 0.3535, z: 18.1274 }
    ],
    [
        { t: 0, x: -1.1712, y: 1.4118, z: 2.5943 },
        { t: 0.016, x: -1.1083, y: 1.4074, z: 3.2461 },
        { t: 0.032, x: -1.0485, y: 1.4, z: 3.8936 },
        { t: 0.048, x: -0.9919, y: 1.3897, z: 4.537 },
        { t: 0.064, x: -0.9385, y: 1.3764, z: 5.1762 },
        { t: 0.08, x: -0.8883, y: 1.3602, z: 5.8111 },
        { t: 0.096, x: -0.8413, y: 1.3411, z: 6.4418 },
        { t: 0.112, x: -0.7974, y: 1.3191, z: 7.0684 },
        { t: 0.128, x: -0.7567, y: 1.2941, z: 7.6907 },
        { t: 0.144, x: -0.7192, y: 1.2663, z: 8.3088 },
        { t: 0.16, x: -0.6848, y: 1.2354, z: 8.9227 },
        { t: 0.176, x: -0.6537, y: 1.2017, z: 9.5324 },
        { t: 0.192, x: -0.6257, y: 1.165, z: 10.1379 },
        { t: 0.208, x: -0.6008, y: 1.1254, z: 10.7392 },
        { t: 0.224, x: -0.5792, y: 1.0829, z: 11.3363 },
        { t: 0.24, x: -0.5607, y: 1.0374, z: 11.9292 },
        { t: 0.256, x: -0.5454, y: 0.989, z: 12.5179 },
        { t: 0.272, x: -0.5333, y: 0.9377, z: 13.1024 },
        { t: 0.288, x: -0.5244, y: 0.8834, z: 13.6826 },
        { t: 0.304, x: -0.5186, y: 0.8263, z: 14.2587 },
        { t: 0.32, x: -0.516, y: 0.7662, z: 14.8305 },
        { t: 0.336, x: -0.5166, y: 0.7031, z: 15.3982 },
        { t: 0.352, x: -0.5204, y: 0.6371, z: 15.9616 },
        { t: 0.368, x: -0.5273, y: 0.5683, z: 16.5208 },
        { t: 0.384, x: -0.5374, y: 0.4964, z: 17.0759 },
        { t: 0.4, x: -0.5507, y: 0.4217, z: 17.6267 },
        { t: 0.4146, x: -0.5656, y: 0.351, z: 18.1249 }
    ],
    [
        { t: 0, x: -1.1177, y: 1.4174, z: 2.6215 },
        { t: 0.016, x: -1.0623, y: 1.4207, z: 3.2761 },
        { t: 0.032, x: -1.0099, y: 1.4212, z: 3.9263 },
        { t: 0.048, x: -0.9606, y: 1.4189, z: 4.5722 },
        { t: 0.064, x: -0.9143, y: 1.4137, z: 5.2137 },
        { t: 0.08, x: -0.8711, y: 1.4057, z: 5.8508 },
        { t: 0.096, x: -0.8308, y: 1.3949, z: 6.4836 },
        { t: 0.112, x: -0.7937, y: 1.3812, z: 7.1121 },
        { t: 0.128, x: -0.7595, y: 1.3647, z: 7.7362 },
        { t: 0.144, x: -0.7284, y: 1.3454, z: 8.3559 },
        { t: 0.16, x: -0.7003, y: 1.3233, z: 8.9713 },
        { t: 0.176, x: -0.6753, y: 1.2983, z: 9.5823 },
        { t: 0.192, x: -0.6532, y: 1.2705, z: 10.1889 },
        { t: 0.208, x: -0.6343, y: 1.2399, z: 10.7912 },
        { t: 0.224, x: -0.6183, y: 1.2064, z: 11.3892 },
        { t: 0.24, x: -0.6054, y: 1.1701, z: 11.9828 },
        { t: 0.256, x: -0.5955, y: 1.131, z: 12.572 },
        { t: 0.272, x: -0.5887, y: 1.089, z: 13.1569 },
        { t: 0.288, x: -0.5849, y: 1.0442, z: 13.7374 },
        { t: 0.304, x: -0.5841, y: 0.9966, z: 14.3136 },
        { t: 0.32, x: -0.5864, y: 0.9461, z: 14.8854 },
        { t: 0.336, x: -0.5917, y: 0.8928, z: 15.4528 },
        { t: 0.352, x: -0.6, y: 0.8367, z: 16.0159 },
        { t: 0.368, x: -0.6114, y: 0.7777, z: 16.5746 },
        { t: 0.384, x: -0.6258, y: 0.716, z: 17.129 },
        { t: 0.4, x: -0.6432, y: 0.6513, z: 17.679 },
        { t: 0.412, x: -0.6583, y: 0.6009, z: 18.0893 }
    ]
]
